import { DatepickerState } from './context';

export type DatepickerAction =
  | { type: 'SET_START_DATE'; payload: Date | null }
  | { type: 'SET_END_DATE'; payload: Date | null }
  | { type: 'SET_RANGE_ERROR'; payload: string | null }
  | { type: 'SET_START_DATE_ERROR'; payload: string | null }
  | { type: 'SET_END_DATE_ERROR'; payload: string | null }
  | { type: 'TOGGLE_RANGE'; payload: boolean };

export function datepickerReducer(
  state: DatepickerState,
  action: DatepickerAction
): DatepickerState {
  switch (action.type) {
    case 'SET_START_DATE':
      return { ...state, startDate: action.payload };
    case 'SET_END_DATE':
      return { ...state, endDate: action.payload };
    case 'SET_RANGE_ERROR':
      if (state.rangeError === action.payload) return state;
      return { ...state, rangeError: action.payload };
    case 'SET_START_DATE_ERROR':
      return { ...state, startDateError: action.payload };
    case 'SET_END_DATE_ERROR':
      return { ...state, endDateError: action.payload };
    case 'TOGGLE_RANGE':
      return { ...state, isRange: action.payload };
    default:
      return state;
  }
}
